import React from 'react';

const POPULAR_ROUTES = [
  { from: 'JFK', to: 'LAX', fromCity: 'New York',       toCity: 'Los Angeles',    price: 129, gradient: 'from-violet-600 to-indigo-700', tag: 'Most Popular'    },
  { from: 'LAX', to: 'SFO', fromCity: 'Los Angeles',    toCity: 'San Francisco',  price: 79,  gradient: 'from-blue-600 to-cyan-600',     tag: 'Best Value'      },
  { from: 'ORD', to: 'MIA', fromCity: 'Chicago',        toCity: 'Miami',          price: 109, gradient: 'from-pink-600 to-rose-700',     tag: 'Beach Getaway'   },
  { from: 'JFK', to: 'MCO', fromCity: 'New York',       toCity: 'Orlando',        price: 99,  gradient: 'from-orange-500 to-amber-600',  tag: 'Family Friendly' },
  { from: 'LAX', to: 'HNL', fromCity: 'Los Angeles',    toCity: 'Honolulu',       price: 249, gradient: 'from-teal-500 to-emerald-600',  tag: 'Paradise'        },
  { from: 'DFW', to: 'ATL', fromCity: 'Dallas',         toCity: 'Atlanta',        price: 89,  gradient: 'from-purple-600 to-violet-700', tag: 'Quick Hop'       },
  { from: 'BOS', to: 'DEN', fromCity: 'Boston',         toCity: 'Denver',         price: 119, gradient: 'from-sky-500 to-blue-700',      tag: 'Mountain Escape' },
  { from: 'SEA', to: 'LAS', fromCity: 'Seattle',        toCity: 'Las Vegas',      price: 95,  gradient: 'from-fuchsia-600 to-pink-700',  tag: 'Weekend Trip'    },
  { from: 'SFO', to: 'AUS', fromCity: 'San Francisco',  toCity: 'Austin',         price: 115, gradient: 'from-green-600 to-teal-700',    tag: 'Tech Hub'        },
];

export default function PopularRoutes() {
  const today = new Date();
  today.setDate(today.getDate() + 7);
  const date = today.toISOString().split('T')[0];

  return (
    <section className="bg-white py-16 sm:py-24 px-4">
      <div className="max-w-6xl mx-auto">

        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 sm:mb-12 gap-3">
          <div>
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2 sm:mb-3">
              Trending Now
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 leading-tight">Popular Routes</h2>
            <p className="text-gray-400 mt-1 sm:mt-2 text-sm sm:text-base">Hand-picked deals refreshed daily</p>
          </div>
          <p className="text-gray-400 text-xs sm:text-sm bg-gray-50 px-3 sm:px-4 py-2 rounded-xl border border-gray-100 self-start sm:self-auto">
            Per person · One-way · Economy
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {POPULAR_ROUTES.map((route) => (
            <a
              key={`${route.from}-${route.to}`}
              href={`/flights?origin=${route.from}&destination=${route.to}&date=${date}&passengers=1&class=economy`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer block"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${route.gradient} transition-all duration-300 group-hover:scale-105`} />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />

              <div className="relative p-5 sm:p-6 flex flex-col justify-between min-h-[130px] sm:min-h-[140px]">
                <div className="flex justify-between items-start">
                  <span className="bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                    {route.tag}
                  </span>
                  <div className="text-right">
                    <p className="text-white/70 text-xs">from</p>
                    <p className="text-white text-xl sm:text-2xl font-black">${route.price}</p>
                  </div>
                </div>

                <div className="mt-3 sm:mt-4">
                  <div className="flex items-center gap-1.5 sm:gap-2 text-white flex-wrap">
                    <span className="font-black text-base sm:text-lg leading-tight">{route.fromCity}</span>
                    <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/60 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                    <span className="font-black text-base sm:text-lg leading-tight">{route.toCity}</span>
                  </div>
                  <p className="text-white/60 text-xs mt-1">{route.from} → {route.to}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
